module.exports = __webpack_public_path__ + "img/switched-on.f2834a2f.svg";